import { render, staticRenderFns } from "./DiagnosticReferrals.vue?vue&type=template&id=4dbf0b15"
import script from "./DiagnosticReferrals.vue?vue&type=script&lang=js"
export * from "./DiagnosticReferrals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports